var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.96973 14.9697L5.03039 16.0303L10.0001 11.0607L14.9697 16.0303L16.0304 14.9697L11.0607 10L16.0304 5.03033L14.9697 3.96967L10.0001 8.93934L5.03039 3.96968L3.96973 5.03033L8.93939 10L3.96973 14.9697Z","fill":"#242424"}));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
